module.exports = __webpack_public_path__ + "img/P150T_weapon_152.9e732484.png";